import React, {useState} from 'react'
import RawTab from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import TabPanel from './TabPanel'
import {useTranslation} from 'react-i18next'

const a11yProps = (index) => {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    }
}

const Tabs = ({tabs}) => {
    const [value, setValue] = useState(0)
    const {t} = useTranslation()
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    return (
        <Box
            sx={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
            }}>
            <RawTab
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                variant="scrollable"
                textColor="inherit"
                scrollButtons="auto"
                aria-label="full width tabs example">
                {tabs.map((item, index) => (
                    <Tab
                        label={t(`${item.translation}.${item.title}`)}
                        {...a11yProps(index)}
                        key={index}
                        sx={{width: 200}}
                    />
                ))}
            </RawTab>
            {tabs.map((item, index) => (
                <TabPanel value={value} index={index} key={index}>
                    {item.content}
                </TabPanel>
            ))}
        </Box>
    )
}

export default Tabs
